import { useMemo } from 'react';
import { notNullOrUndefined } from '~/_shared/utils/typeGuards';
import {
  useBoundaryGroupsSelector, useCheckBoundaryGroupPermissions,
} from '~/store/boundaryGroups/boundaryGroups.selectors';
import { useBoundaryTerritoryGroupsSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';

export const useBoundaryGroupsChartOptions = () => {
  const boundaryTerritoryGroups = useBoundaryTerritoryGroupsSelector();
  const boundaryGroups = useBoundaryGroupsSelector();
  const { checkBoundaryGroupPermissions } = useCheckBoundaryGroupPermissions();

  return useMemo(() => {
    const boundaryGroupsFromBTGs = boundaryTerritoryGroups.map((btg) => {
      const boundaryGroup = boundaryGroups.find(bg => bg.id === btg.boundaryGroupId);
      if (boundaryGroup && checkBoundaryGroupPermissions(boundaryGroup.id).boundaryIsCustom) {
        return {
          id: boundaryGroup.id,
          name: boundaryGroup.name,
        };
      }
      return null;
    }).filter(notNullOrUndefined);

    return [...new Map(boundaryGroupsFromBTGs.map(item => [item.id, item])).values()];
  }, [boundaryGroups, boundaryTerritoryGroups, checkBoundaryGroupPermissions]);
};
